module.exports = __webpack_public_path__ + "media/images/home/mini/4-795a3837e169d8728294a99ad69a3a8d.png";